/**
 * Created by Ning Jiang on 2021-10-11.
 */

import {TombstoneRipSound} from "../sound/TombstoneRipSound";
import {TombstoneRip} from "../TombstoneRip";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Layers, TombstoneRipLayers} from "./TombstoneRipLayers";
import {gsap, TimelineLite} from "gsap";
import {MathHelper} from "../../core/utils/MathHelper";
import {TombstoneRipGameMode} from "../gameflow/TombstoneRipGameMode";

export class ShootingController {

    public static GUN_SHOTGUN:string = "shotgun";
    public static GUN_PISTOL:string = "pistol";

    private static _screenContainer:PIXI.Container;
    private static _leftRed:PIXI.Sprite;
    private static _rightRed:PIXI.Sprite;
    private static _redTimeline:TimelineLite;
    public static _stageInited:boolean = false;

    private static _yellowShotPositions:{ position:PIXI.Point, rotation:number }[] = [
        {position : new PIXI.Point(540, 260), rotation : 21.4},
        {position : new PIXI.Point(532, -205), rotation : -40},
        {position : new PIXI.Point(553, 115), rotation : 9},
        {position : new PIXI.Point(-415, 293), rotation : 158.5},
        {position : new PIXI.Point(-469, -21), rotation : 192},
        {position : new PIXI.Point(448, 249), rotation : 27},
    ];

    public static shotAt(gunType:string, screenEffects:boolean, sparkContainer:PIXI.Container, sparkPosition:PIXI.IPoint, withHole?:boolean, holeContainer?:PIXI.Container, holePosition?:PIXI.IPoint):void {
        TombstoneRipSound.playGunShot(gunType);
        if(withHole) {
            const textures = TombstoneRip.assetLoader.getTextures(`shot/holes/${gunType}_`);
            const hole = new PIXI.Sprite(ArrayHelper.getRandomValue(textures));
            hole.anchor.set(0.5);
            hole.rotation = Math.random() * Math.PI * 2;
            if(gunType === ShootingController.GUN_PISTOL) {
                hole.scale.set(0.5);
            }
            if(holePosition != null) {
                hole.position.set(holePosition.x, holePosition.y);
            } else {
                hole.position.set(sparkPosition.x, sparkPosition.y);
            }
            if(holeContainer != null) {
                holeContainer.addChild(hole);
            } else {
                sparkContainer.addChild(hole);
            }
        }

        if(gunType === ShootingController.GUN_SHOTGUN) {
            const bigSmoke = new TimelineSprite(TombstoneRip.assetLoader.getTextures("shotGun/shotGun_"));
            bigSmoke.anchor.set(0.5);
            bigSmoke.position.set(sparkPosition.x, sparkPosition.y);
            sparkContainer.addChild(bigSmoke);
            const tl = new TimelineLite();
            tl.add(bigSmoke.getAnimationAutoShowHide());
            tl.add(() => {
                if(bigSmoke && bigSmoke.parent) {
                    bigSmoke.parent.removeChild(bigSmoke);
                    bigSmoke.destroy();
                }
            });
        } else {
            const smallSmoke = new TimelineSprite(TombstoneRip.assetLoader.getTextures("SparkSmoke/SparkSmoke_"));
            smallSmoke.blendMode = PIXI.BLEND_MODES.ADD;
            smallSmoke.anchor.set(0.5);
            smallSmoke.position.set(sparkPosition.x, sparkPosition.y);
            sparkContainer.addChild(smallSmoke);
            const tl = new TimelineLite();
            tl.add(smallSmoke.getAnimationAutoShowHide());
            tl.add(() => {
                if(smallSmoke && smallSmoke.parent) {
                    smallSmoke.parent.removeChild(smallSmoke);
                    smallSmoke.destroy();
                }
            });
        }

        if(screenEffects) {
            ShootingController.playScreenAnimation();
        }
    }

    public static playScreenAnimation():void {
        const baseName = TombstoneRip.model.parsedGameData.mode === TombstoneRipGameMode.FREESPIN_SUPER ? "superFS" : "baseFS";

        if(ShootingController._redTimeline && ShootingController._redTimeline.isActive()) {
            ShootingController._redTimeline.pause();
            ShootingController._redTimeline.kill();
        }

        if(!ShootingController._stageInited) {
            ShootingController._screenContainer = new PIXI.Container();
            ShootingController._screenContainer.position.set(360, 360);

            ShootingController._leftRed = new PIXI.Sprite();
            ShootingController._leftRed.blendMode = PIXI.BLEND_MODES.ADD;
            ShootingController._leftRed.anchor.set(1, 0.5);
            ShootingController._leftRed.scale.x = -1;
            ShootingController._leftRed.alpha = 0;
            ShootingController._screenContainer.addChild(ShootingController._leftRed);

            ShootingController._rightRed = new PIXI.Sprite();
            ShootingController._rightRed.blendMode = PIXI.BLEND_MODES.ADD;
            ShootingController._rightRed.anchor.set(1, 0.5);
            ShootingController._rightRed.alpha = 0;
            ShootingController._screenContainer.addChild(ShootingController._rightRed);
            ShootingController._stageInited = true;

            ShootingController.onOrientationChanged();
        }

        TombstoneRipLayers.getLayer(Layers.SCREEN_SHOOT)?.addChild(ShootingController._screenContainer);
        ShootingController._leftRed.texture = TombstoneRip.assetLoader.getTextures(`backgroundEffect/${baseName}/bloodB_02`)[0];
        ShootingController._rightRed.texture = TombstoneRip.assetLoader.getTextures(`backgroundEffect/${baseName}/bloodB_02`)[0];

        if(NolimitApplication.isLandscape) {
            const timeline = new TimelineLite();
            timeline.add([
                gsap.to(this._leftRed, {alpha : 0.87, duration : 0.067}),
                gsap.to(this._rightRed, {alpha : 0.87, duration : 0.067})
            ]);
            timeline.add([
                gsap.to(this._leftRed, {alpha : 0, duration : 0.533}),
                gsap.to(this._rightRed, {alpha : 0, duration : 0.533})
            ]);
            this._redTimeline = timeline;
        }

        let yellow = new TimelineSprite(TombstoneRip.assetLoader.getTextures(`backgroundEffect/${baseName}/gunFire/fire_`));
        yellow.anchor.set(0.5);
        yellow.scale.set(1.5);
        yellow.blendMode = PIXI.BLEND_MODES.ADD;
        const yellowConfig = ArrayHelper.getRandomValue(this._yellowShotPositions);
        yellow.position.set(yellowConfig.position.x, yellowConfig.position.y);
        yellow.rotation = yellowConfig.rotation * Math.PI / 180;
        ShootingController._screenContainer.addChild(yellow);
        yellow.getAnimationAutoShowHide(true, true, undefined, undefined, () => {
            yellow.parent.removeChild(yellow);
            yellow.destroy();
        });

        // randomly play redSpot
        if(Math.random() > 0.5) {
            return;
        }

        let red = new PIXI.Sprite(TombstoneRip.assetLoader.getTextures(`backgroundEffect/${baseName}/bloodA`)[0]);
        red.anchor.set(0.5);
        red.blendMode = PIXI.BLEND_MODES.ADD;
        red.alpha = 0;
        red.scale.set(Math.random() * 0.15 + 0.65);
        red.position.set(MathHelper.randomNumberInRange(-300, 300), MathHelper.randomNumberInRange(-300, 300));
        const randomAlpha = Math.random() * 0.2 + 0.6;
        ShootingController._screenContainer.addChild(red);
        const timeline = gsap.timeline();
        timeline.to(red, {alpha : randomAlpha, duration : 0.067})
            .to(red, {
                alpha : 0, duration : 0.333,
                onComplete : () => {
                    red.parent.removeChild(red);
                    red.destroy();
                }
            });
    }

    public static onOrientationChanged() {
        if(!ShootingController._stageInited) {
            return;
        }
        if(!NolimitApplication.isLandscape) {
            if(this._redTimeline && this._redTimeline.isActive()) {
                this._redTimeline.pause();
                this._redTimeline.kill();
            }
            this._leftRed.alpha = 0;
            this._rightRed.alpha = 0;
            ShootingController._screenContainer.scale.set(1, 1);
        } else {
            ShootingController._screenContainer.scale.set(1.12, 1.12);
        }
        this._leftRed.position.set(-NolimitApplication.screenBounds.width * 0.5, 0);
        this._rightRed.position.set(NolimitApplication.screenBounds.width * 0.5, 0);
    }
}